<template>
    <ContainerLayout page="0" :padding="false">
        <template v-slot:navbar>
            <nav class="navbar navbar-expand navbar-light bg-white text-dark">
                <router-link :to="{ path: '', query: { ...$route.query } }" class="nav-link" @click.prevent="goBack">
                    <font-awesome-icon icon="arrow-left" class="text-dark" />
                </router-link>
                <div class="navbar-nav mr-auto">
                    <li class="nav-item">
                        <h6 class="nav-link mb-0 text-dark font-weight-bold">
                            {{ $route.meta.title }}
                        </h6>
                    </li>
                </div>
            </nav>
            <hr class="my-0" style="height: 1.5px;">
        </template>
        <div class="content px-3 pb-4">
            <div class="row mx-0">
                <div v-for="(data, branchId) in carts" :key="branchId" class="col-12 mb-1 px-0 px-md-2">
                    <div class="d-flex flex-column">
                        <div class="d-flex flex-column py-2">
                            <small style="font-weight: 600;">
                                {{ data.branch_data.current_location_name + ' - ' +
                                    (data.branch_data.location_airport_code ? data.branch_data.location_airport_code +
                                        ', ' : '') + data.branch_data.location_city + ', ' +
                                    data.branch_data.location_province }}
                            </small>
                        </div>
                        <hr class="my-0 full-hr inside-row" style="border-top: 1.5px solid rgba(0,0,0,.1);">
                        <div class="d-flex flex-column py-2">
                            <small style="font-weight: 700; font-size: 12.5px;">
                                {{ $t('Destination') }}
                            </small>
                            <div class="my-1">
                                <div v-if="data.branch_data.name || data.branch_data.brand"
                                    class="d-flex align-items-center">
                                    <small style="font-size: 12px; font-weight: 500;">
                                        {{ data.branch_data.name }} <span style="font-size: 11px; font-weight: 400;">{{
                                            data.branch_data.brand ? ' - ' + data.branch_data.brand : '' }}</span>
                                    </small>
                                </div>
                                <div v-if="data.branch_data.phone" class="d-flex align-items-center">
                                    <small class="text-muted" style="font-size: 11px;">
                                        {{ data.branch_data.phone }}
                                    </small>
                                </div>
                                <div v-if="data.branch_data.address" class="d-flex align-items-center">
                                    <small class="text-muted" style="font-size: 11px;">
                                        {{ data.branch_data.address }}
                                    </small>
                                </div>
                                <div v-if="data.branch_data.receiver_name || data.branch_data.receiver_phone"
                                    class="d-flex align-items-center">
                                    <small style="font-size: 11px;">
                                        {{ $t('PIC') }} : {{ data.branch_data.receiver_name }}
                                        ({{ data.branch_data.receiver_phone }})
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr class="my-0 full-hr inside-row" style="border-top: 7px solid rgba(0,0,0,.1);">
                    <div class="row mx-0">
                        <div v-for="(item, key) in data.grouped_carts" :key="key" class="col-12 mb-1 px-0 px-md-2">
                            <div class="w-100 row mx-0 mt-3">
                                <div class="col-12 mb-3 px-2">
                                    <div class="h-100 card-container d-flex">
                                        <div class="w-100 card"
                                            style="border-radius: 0.25rem; box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2); border: 1.5px solid rgba(0,0,0,.125); display: flex; flex-direction: column; justify-content: space-between;">
                                            <div class="my-2 mx-3 pb-2">
                                                <div class="row">
                                                    <div class="col-9">
                                                        <div
                                                            class="d-flex flex-column justify-content-start align-items-start">
                                                            <small style="font-weight: 600;">{{
                                                                item.product_detail.product.current_name
                                                            }}</small>
                                                            <small class="text-muted" style="font-size: 13px;">{{
                                                                item.product_detail.product.product_category.name
                                                            }}</small>
                                                            <small class="text-main" style="font-weight: 700;">{{
                                                                item.total_price_formatted
                                                            }}</small>
                                                            <div>
                                                                <div class="badge badge-main mr-1">
                                                                    {{ item.product_detail.detail_label }}
                                                                </div>
                                                                <div v-if="item.cart_addons.length > 0"
                                                                    class="badge badge-outline badge-main mr-1">
                                                                    + {{ item.cart_addons.length }} {{
                                                                        item.cart_addons.length >
                                                                        1 ? $t('Bundles') : $t('Bundle') }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-3">
                                                        <div class="h-100 d-flex justify-content-end align-items-center">
                                                            <img :src="item.product_detail.product.image_url"
                                                                style="width: 30px; height: auto;">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-footer p-1">
                                                <div class="d-flex align-items-center px-2 py-1">
                                                    <img :src="item.product_detail.product.provider.image_url"
                                                        class="img-fluid mr-1" style="width: 25px; height: auto;">
                                                    <p class="mb-0" style="font-weight: 500; font-size: 10px;">{{
                                                        item.product_detail.product.provider.name
                                                    }}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr class="mt-2 mb-1 full-hr inside-row-second" style="border-top: 7px solid rgba(0,0,0,.1);">
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-100 d-flex flex-column mt-2">
                <small class="font-weight-bold" style="font-size: 15px;">{{ $t('Purchase Summary') }}</small>
                <div v-for="(data, branchId) in carts" :key="branchId">
                    <!-- <small class="font-weight-bold mt-1" style="font-size: 12px;">
                        {{ data.branch_data.name }} ({{ data.branch_data.brand }})
                    </small> -->
                    <div class="d-flex flex-row align-items-center mt-1">
                        <small style="font-size: 12px;">
                            {{ getTotalProductLabel(data.grouped_carts) }}
                        </small>
                        <small class="ml-auto" style="font-size: 12px;">
                            {{ getTotalProductPriceLabel(data.grouped_carts) }}
                        </small>
                    </div>
                    <div v-if="getTotalProductAddon(data.grouped_carts) > 0"
                        class="d-flex flex-row align-items-center mt-1">
                        <small style="font-size: 12px;">
                            {{ getTotalProductAddonLabel(data.grouped_carts) }}
                        </small>
                        <small class="ml-auto" style="font-size: 12px;">
                            {{ getTotalProductAddonPriceLabel(data.grouped_carts) }}
                        </small>
                    </div>
                </div>
                <div v-if="cart_data">
                    <hr class="mt-3 mb-2" style="border-top: 1.5px solid rgba(0,0,0,.1);">
                    <div class="d-flex flex-row align-items-center mt-1">
                        <small style="font-size: 12px;">
                            {{ $t('Subtotal') }}
                        </small>
                        <small class="ml-auto" style="font-size: 12px;">
                            {{ cart_data ? formatPrice(cart_data.original_amount) : '-' }}
                        </small>
                    </div>
                    <div v-if="cart_data && cart_data.has_vat">
                        <div class="d-flex flex-row align-items-center mt-1">
                            <small style="font-size: 12px;">
                                {{ cart_data ? cart_data.vat_label : '-' }}
                            </small>
                            <small class="ml-auto" :class="cart_data && cart_data.total_vat < 0 ? 'text-danger' : ''"
                                style="font-size: 12px;">
                                {{ cart_data ? formatPrice(cart_data.total_vat) : '-' }}
                            </small>
                        </div>
                    </div>
                    <div v-if="cart_data && cart_data.has_pph">
                        <div class="d-flex flex-row align-items-center mt-1">
                            <small style="font-size: 12px;">
                                {{ cart_data ? cart_data.pph_label : '-' }}
                            </small>
                            <small class="ml-auto" :class="cart_data && cart_data.total_pph < 0 ? 'text-danger' : ''"
                                style="font-size: 12px;">
                                {{ cart_data ? formatPrice(cart_data.total_pph) : '-' }}
                            </small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <template v-slot:bottom-bar>
            <div class="w-100 d-flex flex-column card-footer">
                <div class="w-100 d-flex justify-content-end align-items-center">
                    <div class="d-flex flex-column">
                        <small style="font-weight: 700;">
                            {{ $t('Purchase Total') }}
                        </small>
                        <small class="text-main" style="font-weight: 700; font-size: 15px;">
                            {{ cart_data ? formatPrice(cart_data.amount) : getTotalPriceLabel(carts) }}
                        </small>
                    </div>
                    <div class="ml-auto">
                        <button
                            v-if="cart_data && cart_data.branch && cart_data.branch.company && cart_data.branch.company.customer_id == 'APSD.COMP2023001'"
                            id="btn-env" class="btn btn-sm btn-outline-secondary mr-1" @click.prevent="changeEnvironment()"
                            style="border-radius: 10px; min-width: 100px;" :disabled="loading">
                            {{ cart_data.branch.company.environment == 'sandbox' ? 'Sandbox' : 'Live' }}
                        </button>
                        <button class="btn btn-sm btn-main" @click.prevent="goToPayment()"
                            style="border-radius: 10px; min-width: 100px;" :disabled="loading">
                            {{ $t('Choose Payment') }}
                        </button>
                    </div>
                </div>
            </div>
        </template>
    </ContainerLayout>
</template>

<script>
import ContainerLayout from "../ContainerLayout.vue";
import CartService from "@/services/cart.service";
import CompanyService from "@/services/company.service";
import TransactionService from "@/services/transaction.service";
import "@webzlodimir/vue-bottom-sheet/dist/style.css";

export default {
    name: "PaymentIndex",
    components: {
        ContainerLayout,
    },
    data() {
        return {
            loading: false,
            cart_ids: [],
            carts: [],
            cart_data: null,
        };
    },
    computed: {
        currentUser() {
            return localStorage.getItem('loggedData') ? JSON.parse(localStorage.getItem('loggedData')).user : null;
        },
    },
    created() {
        this.loading = true;
        let loader = this.$loading.show();
        if (!this.$route.query.data) {
            this.loading = false;
            loader.hide();
            this.$router.push({
                name: "Cart",
                query: { from: 'checkout' }
            });
        } else {
            let decrypted = this.$decryptString(this.$route.query.data, 'encryptKey');
            if (decrypted == null) {
                this.loading = false;
                loader.hide();
                this.$router.push({
                    name: "Cart",
                    query: { from: 'checkout' }
                });
            } else {
                this.cart_ids = decrypted;
                let data = { cart_ids: JSON.parse(this.cart_ids) };
                CartService
                    .getByCartIds(data)
                    .then((response) => {
                        this.loading = false;
                        loader.hide();
                        if (response.data.status === "success") {
                            this.carts = response.data.data;
                            this.cart_data = response.data.cart_data;

                            if (Object.keys(this.carts).length == 0) {
                                this.$vueAlert.alert(this.$t('Your cart is empty!'), null, 'warning').then(() => {
                                    this.$router.push({
                                        name: "Cart",
                                        query: { from: 'checkout' }
                                    });
                                });
                            }
                        } else {
                            this.$vueAlert.alert(response.data.message, null, response.data.status).then(() => {
                                this.$router.push({
                                    name: "Cart",
                                    query: { from: 'checkout' }
                                });
                            });
                        }
                    })
                    .catch((error) => {
                        this.loading = false;
                        loader.hide();

                        let errorMessage = this.$t('An error occurred');
                        if (error.response) {
                            if (error.response.status == 401) {
                                this.$store.dispatch("auth/logout");
                                this.$router.push('/login');
                                return; // Exit the function after handling 401
                            }

                            // Check if the message is available in the error response
                            if (error.response.data && error.response.data.message) {
                                errorMessage = error.response.data.message;
                            } else if (error.response.statusText) {
                                // Fallback to statusText if message is not available
                                errorMessage = error.response.statusText;
                            }
                        } else if (error.message) {
                            // Fallback to error.message if response is not available
                            errorMessage = error.message;
                        }

                        this.$vueAlert.alert(errorMessage, null, 'error').then(() => {
                            this.$router.push({
                                name: "Cart",
                                query: { from: 'checkout' }
                            });
                        });
                    });
            }
        }
    },
    methods: {
        goBack() {
            if (this.$route.query.from == 'cart') {
                this.$router.push({
                    name: "Cart",
                    query: { from: 'checkout' }
                });
            } else {
                this.navigateBackOrHome();
            }
        },

        restoreByCartIds(message = null) {
            this.$vueAlert.alert(message, null, 'error').then(() => {
                let data = { cart_ids: JSON.parse(this.cart_ids) };
                CartService
                    .restoreByCartIds(data)
                    .then(() => {
                        this.$router.push({
                            name: "Cart",
                            query: { from: 'checkout' }
                        });
                    })
                    .catch(() => {
                        this.$router.push({
                            name: "Cart",
                            query: { from: 'checkout' }
                        });
                    });
            });
        },

        getTotalProduct(carts) {
            let total = 0;
            carts.forEach(() => {
                total += 1;
            });
            return total;
        },

        getTotalProductLabel(carts) {
            let total = this.getTotalProduct(carts);
            return total.toString() + ' ' + (total > 1 ? this.$t('Products') : this.$t('Product'));
        },

        getTotalProductPrice(carts) {
            let total = 0;
            carts.forEach((product) => {
                total += parseFloat(product.price);
            });
            return total;
        },

        formatPrice(price) {
            let formatter = new Intl.NumberFormat('id-ID', {
                style: 'currency',
                currency: 'IDR',
            });
            let price_string = formatter.format(price);
            if (price_string.includes(",00")) {
                price_string = price_string.replace(",00", "");
            }
            return price_string;
        },

        getTotalProductPriceLabel(carts) {
            let total = this.getTotalProductPrice(carts);
            return this.formatPrice(total);
        },

        getTotalProductAddon(carts) {
            let total = 0;
            carts.forEach((product) => {
                total += product.cart_addons.length;
            });
            return total;
        },

        getTotalProductAddonLabel(carts) {
            let total = this.getTotalProductAddon(carts);
            return total.toString() + ' ' + (total > 1 ? this.$t('Bundles') : this.$t('Bundle'));

        },

        getTotalProductAddonPrice(carts) {
            let total = 0;
            carts.forEach((product) => {
                product.cart_addons.forEach((addon) => {
                    total += parseFloat(addon.price);
                });
            });
            return total;
        },

        getTotalProductAddonPriceLabel(carts) {
            let total = this.getTotalProductAddonPrice(carts);
            return this.formatPrice(total);
        },

        getTotalPrice(carts) {
            let total = 0;
            for (const locationData in carts) {
                const providers = carts[locationData].grouped_carts;
                total += this.getTotalProductPrice(providers) + this.getTotalProductAddonPrice(providers);
            }
            return total;
        },

        getTotalPriceLabel(carts) {
            let total = this.getTotalPrice(carts);
            return this.formatPrice(total);
        },

        goToPayment() {
            this.loading = true;
            let loader = this.$loading.show();
            let data = {
                user_id: this.currentUser.id,
                original_amount: this.getTotalPrice(this.carts),
                cart_ids: JSON.parse(this.cart_ids),
            };
            TransactionService
                .store(data)
                .then((response) => {
                    this.loading = false;
                    loader.hide();
                    if (response.data.status === "success") {
                        this.$router.push({
                            name: "Payment",
                            query: {
                                data: this.$encryptString(response.data.data.id, 'encryptKey')
                            }
                        });
                    } else {
                        if (response.data.data && response.data.data.id) {
                            this.$vueAlert.alert(response.data.message, null, 'error').then(() => {
                                this.$router.push({
                                    name: "Transaction",
                                });
                            });
                        } else {
                            this.restoreByCartIds(response.data.message);
                        }
                    }
                })
                .catch((error) => {
                    this.loading = false;
                    loader.hide();

                    let errorMessage = this.$t('An error occurred');
                    if (error.response) {
                        if (error.response.status == 401) {
                            this.$store.dispatch("auth/logout");
                            this.$router.push('/login');
                            return; // Exit the function after handling 401
                        }

                        // Check if the message is available in the error response
                        if (error.response.data && error.response.data.message) {
                            errorMessage = error.response.data.message;
                        } else if (error.response.statusText) {
                            // Fallback to statusText if message is not available
                            errorMessage = error.response.statusText;
                        }
                    } else if (error.message) {
                        // Fallback to error.message if response is not available
                        errorMessage = error.message;
                    }

                    // this.$vueAlert.alert(errorMessage, null, 'error');
                    this.restoreByCartIds(errorMessage);
                });
        },

        changeEnvironment() {
            let company_id = this.cart_data && this.cart_data.branch && this.cart_data.branch.company && this.cart_data.branch.company.id ? this.cart_data.branch.company.id : null;
            let environment = this.cart_data && this.cart_data.branch && this.cart_data.branch.company && this.cart_data.branch.company.environment ? this.cart_data.branch.company.environment : null;
            if (company_id && environment) {
                this.loading = true;
                let loader = this.$loading.show();

                environment = environment == 'sandbox' ? 'live' : 'sandbox';
                let data = {
                    environment: environment,
                };

                CompanyService
                    .update(company_id, data)
                    .then((response) => {
                        this.loading = false;
                        loader.hide();
                        if (response.data.status == 'success') {
                            let btnEnv = document.getElementById('btn-env');
                            if (btnEnv) {
                                btnEnv.innerHTML = environment == 'sandbox' ? 'Sandbox' : 'Live';
                                btnEnv.blur();
                            }

                            this.cart_data.branch.company.environment = environment;
                        } else {
                            this.$vueAlert.alert(response.data.message, null, 'error');
                        }
                    })
                    .catch((error) => {
                        this.loading = false;
                        loader.hide();

                        let errorMessage = this.$t('An error occurred');
                        if (error.response) {
                            if (error.response.status == 401) {
                                this.$store.dispatch("auth/logout");
                                this.$router.push('/login');
                                return; // Exit the function after handling 401
                            }

                            // Check if the message is available in the error response
                            if (error.response.data && error.response.data.message) {
                                errorMessage = error.response.data.message;
                            } else if (error.response.statusText) {
                                // Fallback to statusText if message is not available
                                errorMessage = error.response.statusText;
                            }
                        } else if (error.message) {
                            // Fallback to error.message if response is not available
                            errorMessage = error.message;
                        }

                        this.$vueAlert.alert(errorMessage, null, 'error');
                    });
            }
        }
    }
};
</script>

<style scoped>
.full-hr {
    margin-left: -15px;
    margin-right: -15px;
}

@media (min-width: 768px) {
    .full-hr {
        margin-left: -15px;
        margin-right: -15px;
    }

    .full-hr.inside-row {
        margin-left: -24px;
        margin-right: -24px;
    }

    .full-hr.inside-row-second {
        margin-left: -32px;
        margin-right: -32px;
    }
}
</style>